import { RECEIVE_ACCOUNT_SETTING_DATA } from "./actions";

import type { Action } from "./store";

export const accountSetting = (state: any = {}, action: Action): string => {
  if (action.type === RECEIVE_ACCOUNT_SETTING_DATA) {
    return { ...state, ...action.payload };
  }
  return state;
};
